/**
 * Batched low lift test 5, test 3:
 * PRD: https:www.notion.so/faire/Low-lift-testing-Batch-5-
 * 528305362d4d4455a8d8ad0edaf65767?pvs=4#1072efb5c25a8031bc6ad4a3e802b6d2
 */
export const BATCH_5_REPLACE_TESTIMONIALS_ON_LOGGED_OUT_BRAND_102124 = 'BATCH_5_REPLACE_TESTIMONIALS_ON_LOGGED_OUT_BRAND_102124';
